webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_configs_ProductsConfig__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProductsConfig: __WEBPACK_IMPORTED_MODULE_0__components_configs_ProductsConfig__["a" /* default */] },
  data: function data() {
    return {
      drawer: false,
      menuItems: [{ icon: 'event', title: 'Eventos', selected: false, action: this.goEvents }, { icon: 'assignment_ind', title: 'Validar', selected: false, action: this.goHome }, { icon: 'history', title: 'Histórico', selected: false, action: this.goValidations }, { divider: true },
      // { icon: 'settings_applications', title: 'Configurações', selected: false, action: this.goConfig },
      { icon: 'exit_to_app', title: 'Sair', selected: false, action: this.logout }],
      menuItemSelected: {}
    };
  },

  computed: {
    inLoginPage: function inLoginPage() {
      return this.$route.name === 'Login';
    },
    inValidationTabPage: function inValidationTabPage() {
      return this.$route.name === 'ValidationTab';
    },
    title: function title() {
      return this.$store.getters.currentPage;
    },

    snackbarOpen: {
      get: function get() {
        return this.$store.getters.snackbarOpen;
      },
      set: function set(value) {
        this.$store.dispatch('setSnackbarOpen', value);
      }
    },
    snackbarColor: function snackbarColor() {
      return this.$store.getters.snackbarColor;
    },
    snackbarMessage: function snackbarMessage() {
      return this.$store.getters.snackbarMessage;
    },
    userName: function userName() {
      return this.$store.getters.userName;
    },
    colorClass: function colorClass() {
      return this.$store.getters.colorClass;
    },
    isDark: function isDark() {
      return this.$store.getters.isDark;
    }
  },
  methods: {
    goHome: function goHome() {
      this.closeMenu();
      this.$router.push('/');
    },
    goEvents: function goEvents() {
      this.closeMenu();
      this.$router.push('/events');
    },
    goValidations: function goValidations() {
      this.closeMenu();
      this.$router.push('/validations');
    },
    goConfig: function goConfig() {
      this.closeMenu();
      this.$router.push('/config');
    },
    logout: function logout() {
      this.$store.dispatch('doLogout');
      this.$router.push('/login');
      this.closeMenu();
    },
    closeMenu: function closeMenu() {
      this.drawer = false;
    },
    openProductsDialog: function openProductsDialog() {
      this.$store.dispatch('openProductsConfigDialog');
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsConfig_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46357bce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsConfig_vue__ = __webpack_require__(156);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46357bce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    products: {
      get: function get() {
        return this.$store.getters.products;
      }
    },
    selectedAll: {
      get: function get() {
        return this.$store.getters.products.length === this.$store.getters.products.filter(function (product) {
          return product.enabled;
        }).length;
      },
      set: function set(value) {
        this.toggleAll(value);
      }
    },
    selectedEvent: function selectedEvent() {
      return this.$store.getters.selectedEvent;
    },

    dialog: {
      get: function get() {
        return this.$store.getters.productsConfigDialog;
      },
      set: function set(value) {
        if (!value) {
          this.$store.dispatch('closeProductsConfigDialog');
        }
      }
    }
  },
  methods: {
    toggleAll: function toggleAll(value) {
      this.$store.dispatch('toggleAllProductsValidation', value);
    },
    toggleProduct: function toggleProduct(product) {
      this.$store.dispatch('toggleProductValidation', product);
    },
    fetchProducts: function fetchProducts() {
      this.$store.dispatch('setProductsList', this.selectedEvent.id);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QRCodeValidation__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextValidation__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListValidation__ = __webpack_require__(185);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { QrcodeValidation: __WEBPACK_IMPORTED_MODULE_0__QRCodeValidation__["a" /* default */], TextValidation: __WEBPACK_IMPORTED_MODULE_1__TextValidation__["a" /* default */], ListValidation: __WEBPACK_IMPORTED_MODULE_2__ListValidation__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('setCurrentPage', this.$store.getters.selectedEvent.name);
  },
  data: function data() {
    return {
      cameraPaused: false
    };
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__ = __webpack_require__(12);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { QrcodeReader: __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__["QrcodeReader"] },
  props: ['paused'],
  created: function created() {
    this.internalPaused = this.paused;
  },
  data: function data() {
    return {
      lastExecution: new Date(),
      internalPaused: false
    };
  },

  computed: {
    eventId: function eventId() {
      return this.$store.getters.selectedEvent.id;
    }
  },
  methods: {
    onDecode: function onDecode(decodedString) {
      var _this = this;

      this.internalPaused = true;
      setTimeout(function () {
        _this.internalPaused = false;
      }, 100);
      var currentTime = new Date();
      if (currentTime.getTime() > this.lastExecution.getTime() + 1500) {
        this.lastExecution = new Date();
        if (decodedString.includes('wixevents.com')) {
          var ticketRegex = decodedString.match(/[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]*/gm);
          decodedString = ticketRegex[0];
        }
        // if (decodedString.length >= 8 && decodedString.length <= 20) {
        this.$store.dispatch('readTicket', { ticket: decodedString, eventId: this.eventId });
        // } else {
        //   this.$store.dispatch('setSnackbarColor', 'error')
        //   this.$store.dispatch('setSnackbarMessage', 'Ingresso inválido')
        //   this.$store.dispatch('setSnackbarOpen', true)
        // }
      }
    }
  }
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ticket: ''
    };
  },

  computed: {
    eventId: function eventId() {
      return this.$store.getters.selectedEvent.id;
    },
    colorClass: function colorClass() {
      return this.$store.getters.colorClass;
    },
    isDark: function isDark() {
      return this.$store.getters.isDark;
    }
  },
  methods: {
    submit: function submit() {
      if (this.ticket.includes('wixevents.com')) {
        var ticketRegex = this.ticket.match(/[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]*/gm);
        this.ticket = ticketRegex[0];
      }
      this.$store.dispatch('readTicket', { ticket: this.ticket, eventId: this.eventId });
      this.ticket = '';
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchField: null
    };
  },

  watch: {
    searchField: function searchField(value) {
      if (value === '') {
        this.searchField = null;
      }
    }
  },
  computed: {
    eventId: function eventId() {
      return this.$store.getters.selectedEvent.id;
    },
    tickets: function tickets() {
      var _this = this;

      return this.$store.getters.tickets.filter(function (ticket) {
        if (ticket.buyer) {
          return ticket.buyer.includes(_this.searchField) || _this.searchField === null;
        }
      });
    },
    colorClass: function colorClass() {
      return this.$store.getters.colorClass;
    },
    isDark: function isDark() {
      return this.$store.getters.isDark;
    }
  },
  methods: {
    validate: function validate(ticket) {
      this.$store.dispatch('readTicket', { ticket: ticket.code, eventId: this.eventId });
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch('setCurrentPage', 'Histórico de validações');
  },

  computed: {
    ticketsReaded: function ticketsReaded() {
      return this.$store.getters.readed;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('h:mm:ss a');
    }
  }
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductsConfig__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProductsConfig: __WEBPACK_IMPORTED_MODULE_0__ProductsConfig__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('setCurrentPage', 'Configurações');
  },

  methods: {
    openProductsDialog: function openProductsDialog() {
      this.$store.dispatch('openProductsConfigDialog');
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch('setEventsList', this.$store.getters.userId);
    this.$store.dispatch('setCurrentPage', 'Eventos');
  },

  computed: {
    events: function events() {
      return this.$store.getters.eventsList;
    }
  },
  methods: {
    downloadTickets: function downloadTickets(event) {
      this.$store.dispatch('setSelectedEvent', event);
      this.$store.dispatch('setProductsList', event.id);
      this.$store.dispatch('setEventTickets', event.id);
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch('setCurrentPage', '');
  },
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      this.$store.dispatch('doLogin', { email: this.email, password: this.password, router: this.$router });
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_store__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_qrcode_reader__ = __webpack_require__(12);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// import colors from 'vuetify/es5/util/colors'

window.addEventListener('online', function (e) {
  __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('syncTickets');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuetify___default.a, {
  theme: {
    primary: '#005D8A'
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_qrcode_reader__["default"]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.options.root = "https://checkin.lebillet.com.br/api";
var hostname = window.location.hostname;
var documentApp = 'Checkin';
if (hostname.includes('swap') || hostname.includes('troca')) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Validation'] = 'swap';
  documentApp = " | Troca";
}
document.title = "lebillet" + ' | ' + documentApp;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Access-Control-Allow-Credentials'] = 'true';
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.headers.common['Accept'] = 'application/json, text/plain, */*';

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({ routes: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */], mode: 'history' });

__WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('loadEventFromLocalStore');
__WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('loadProductsFromLocalStore');
__WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('loadTicketsFromLocalStore');
__WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('loadTicketsReadedFromLocalStore');

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('tryAutoLogin');
  var userId = __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].getters.userId;
  if ((userId === null || userId === 0) && to.path !== '/login') {
    next('/login');
  } else {
    var selectedEvent = __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].getters.selectedEvent;
    if (!selectedEvent.id && to.path === '/') {
      __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('setSnackbarColor', 'error');
      __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('setSnackbarMessage', 'Selecione um evento');
      __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */].dispatch('setSnackbarOpen', true);
      next('/events');
    } else {
      next();
    }
  }
});

Object(__WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */], router);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_9__store_store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b87f553_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(157);
function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b87f553_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n      Produtos e setores disponíveis para validação\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"color":"primary","label":"Todos os setores"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.selectedAll != _vm.selectedAll}},model:{value:(_vm.selectedAll),callback:function ($$v) {_vm.selectedAll=$$v},expression:"selectedAll"}}),_vm._v(" "),_vm._l((_vm.products),function(product,index){return [_c('v-checkbox',{key:index,attrs:{"label":((product.name) + " - " + (product.typeName)),"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.toggleProduct(product)}},model:{value:(product.enabled),callback:function ($$v) {_vm.$set(product, "enabled", $$v)},expression:"product.enabled"}})]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","outline":""},on:{"click":function($event){$event.stopPropagation();return _vm.fetchProducts($event)}}},[_vm._v("Atualizar")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = false}}},[_vm._v("Fechar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.colorClass,attrs:{"dark":_vm.isDark}},[_c('v-navigation-drawer',{class:_vm.colorClass,attrs:{"fixed":"","clipped":"","app":"","dark":_vm.isDark},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-subheader',[_vm._v("Usuário")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("face")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.userName))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.menuItems),function(item,i){return [(item.divider)?_c('v-divider',{key:i}):_c('v-list-tile',{key:i,attrs:{"value":_vm.menuItemSelected === item},on:{"click":function($event){_vm.menuItemSelected = item
            item.action()}}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1)]})],2)],1),_vm._v(" "),(!_vm.inLoginPage)?_c('v-toolbar',{attrs:{"app":"","clipped-left":"","dark":"","color":"primary"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.inValidationTabPage)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.openProductsDialog}},[_c('v-icon',[_vm._v("settings")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-content',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('v-snackbar',{staticClass:"my-stackbar",attrs:{"color":_vm.snackbarColor,"timeout":3000,"multi-line":"","vertical":"","top":""},model:{value:(_vm.snackbarOpen),callback:function ($$v) {_vm.snackbarOpen=$$v},expression:"snackbarOpen"}},[_c('h2',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.snackbarMessage))])]),_vm._v(" "),_c('products-config')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_validation_ValidationTab__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_validation_ValidationHistory__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_configs_Configs__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_events_EventsList__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Login__ = __webpack_require__(197);






/* harmony default export */ __webpack_exports__["a"] = ([{ path: '/', name: 'ValidationTab', component: __WEBPACK_IMPORTED_MODULE_0__components_validation_ValidationTab__["a" /* default */] }, { path: '/validations', name: 'ValidationHistory', component: __WEBPACK_IMPORTED_MODULE_1__components_validation_ValidationHistory__["a" /* default */] }, { path: '/config', name: 'Configs', component: __WEBPACK_IMPORTED_MODULE_2__components_configs_Configs__["a" /* default */] }, { path: '/events', name: 'Events', component: __WEBPACK_IMPORTED_MODULE_3__components_events_EventsList__["a" /* default */] }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Login__["a" /* default */] }]);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationTab_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054151ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationTab_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054151ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCodeValidation_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613068ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCodeValidation_vue__ = __webpack_require__(181);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCodeValidation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613068ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCodeValidation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qrcode-reader',{attrs:{"paused":_vm.internalPaused},on:{"decode":_vm.onDecode}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextValidation_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1bddec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextValidation_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a1bddec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextValidation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1bddec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextValidation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:_vm.colorClass,attrs:{"fluid":"","dark":_vm.isDark}},[_c('div',{staticClass:"text-validation"},[_c('div',[_c('v-text-field',{class:_vm.colorClass,attrs:{"dark":_vm.isDark,"label":"Ingresso","type":"tel","required":"","autofocus":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListValidation_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed86518_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListValidation_vue__ = __webpack_require__(187);
function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListValidation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed86518_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListValidation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{class:_vm.colorClass,attrs:{"two-line":"","subheader":"","dark":_vm.isDark}},[_c('div',{staticClass:"searchInput"},[_c('v-text-field',{attrs:{"label":"Buscar comprador","clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.searchField),callback:function ($$v) {_vm.searchField=$$v},expression:"searchField"}})],1),_vm._v(" "),_vm._l((_vm.tickets),function(ticket,i){return _c('v-list-tile',{key:i,class:_vm.colorClass,attrs:{"avatar":"","dark":_vm.isDark}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(ticket.buyer))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(ticket.code))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){_vm.validate(ticket)}}},[(ticket.status === 'Cancelado')?_c('v-icon',{attrs:{"dark":_vm.isDark,"color":"error lighten-1"}},[_vm._v("cancel")]):(ticket.readed)?_c('v-icon',{attrs:{"dark":_vm.isDark,"color":"primary lighten-1"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"dark":_vm.isDark,"color":"primary lighten-1"}},[_vm._v("check")])],1)],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"icons-and-text":"","dense":"","centered":"","fixed-tabs":"","color":"transparent"}},[_c('v-tabs-slider',{attrs:{"color":"primary"}}),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"},on:{"click":function($event){_vm.cameraPaused = true}}},[_vm._v("\n    Manual\n    "),_c('v-icon',[_vm._v("text_format")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"},on:{"click":function($event){_vm.cameraPaused = false}}},[_vm._v("\n    Camera\n    "),_c('v-icon',[_vm._v("camera_alt")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3"},on:{"click":function($event){_vm.cameraPaused = true}}},[_vm._v("\n    Lista\n    "),_c('v-icon',[_vm._v("contacts")])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-1"}},[(!_vm.cameraPaused)?_c('qrcode-validation',{attrs:{"paused":_vm.cameraPaused}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card',{attrs:{"flat":""}},[_c('text-validation')],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-3"}},[_c('v-card',{attrs:{"flat":""}},[_c('list-validation')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationHistory_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7468a8f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationHistory_vue__ = __webpack_require__(192);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7468a8f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 19,
	"./af.js": 19,
	"./ar": 20,
	"./ar-dz": 21,
	"./ar-dz.js": 21,
	"./ar-kw": 22,
	"./ar-kw.js": 22,
	"./ar-ly": 23,
	"./ar-ly.js": 23,
	"./ar-ma": 24,
	"./ar-ma.js": 24,
	"./ar-sa": 25,
	"./ar-sa.js": 25,
	"./ar-tn": 26,
	"./ar-tn.js": 26,
	"./ar.js": 20,
	"./az": 27,
	"./az.js": 27,
	"./be": 28,
	"./be.js": 28,
	"./bg": 29,
	"./bg.js": 29,
	"./bm": 30,
	"./bm.js": 30,
	"./bn": 31,
	"./bn.js": 31,
	"./bo": 32,
	"./bo.js": 32,
	"./br": 33,
	"./br.js": 33,
	"./bs": 34,
	"./bs.js": 34,
	"./ca": 35,
	"./ca.js": 35,
	"./cs": 36,
	"./cs.js": 36,
	"./cv": 37,
	"./cv.js": 37,
	"./cy": 38,
	"./cy.js": 38,
	"./da": 39,
	"./da.js": 39,
	"./de": 40,
	"./de-at": 41,
	"./de-at.js": 41,
	"./de-ch": 42,
	"./de-ch.js": 42,
	"./de.js": 40,
	"./dv": 43,
	"./dv.js": 43,
	"./el": 44,
	"./el.js": 44,
	"./en-au": 45,
	"./en-au.js": 45,
	"./en-ca": 46,
	"./en-ca.js": 46,
	"./en-gb": 47,
	"./en-gb.js": 47,
	"./en-ie": 48,
	"./en-ie.js": 48,
	"./en-il": 49,
	"./en-il.js": 49,
	"./en-nz": 50,
	"./en-nz.js": 50,
	"./eo": 51,
	"./eo.js": 51,
	"./es": 52,
	"./es-do": 53,
	"./es-do.js": 53,
	"./es-us": 54,
	"./es-us.js": 54,
	"./es.js": 52,
	"./et": 55,
	"./et.js": 55,
	"./eu": 56,
	"./eu.js": 56,
	"./fa": 57,
	"./fa.js": 57,
	"./fi": 58,
	"./fi.js": 58,
	"./fo": 59,
	"./fo.js": 59,
	"./fr": 60,
	"./fr-ca": 61,
	"./fr-ca.js": 61,
	"./fr-ch": 62,
	"./fr-ch.js": 62,
	"./fr.js": 60,
	"./fy": 63,
	"./fy.js": 63,
	"./gd": 64,
	"./gd.js": 64,
	"./gl": 65,
	"./gl.js": 65,
	"./gom-latn": 66,
	"./gom-latn.js": 66,
	"./gu": 67,
	"./gu.js": 67,
	"./he": 68,
	"./he.js": 68,
	"./hi": 69,
	"./hi.js": 69,
	"./hr": 70,
	"./hr.js": 70,
	"./hu": 71,
	"./hu.js": 71,
	"./hy-am": 72,
	"./hy-am.js": 72,
	"./id": 73,
	"./id.js": 73,
	"./is": 74,
	"./is.js": 74,
	"./it": 75,
	"./it.js": 75,
	"./ja": 76,
	"./ja.js": 76,
	"./jv": 77,
	"./jv.js": 77,
	"./ka": 78,
	"./ka.js": 78,
	"./kk": 79,
	"./kk.js": 79,
	"./km": 80,
	"./km.js": 80,
	"./kn": 81,
	"./kn.js": 81,
	"./ko": 82,
	"./ko.js": 82,
	"./ky": 83,
	"./ky.js": 83,
	"./lb": 84,
	"./lb.js": 84,
	"./lo": 85,
	"./lo.js": 85,
	"./lt": 86,
	"./lt.js": 86,
	"./lv": 87,
	"./lv.js": 87,
	"./me": 88,
	"./me.js": 88,
	"./mi": 89,
	"./mi.js": 89,
	"./mk": 90,
	"./mk.js": 90,
	"./ml": 91,
	"./ml.js": 91,
	"./mn": 92,
	"./mn.js": 92,
	"./mr": 93,
	"./mr.js": 93,
	"./ms": 94,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 94,
	"./mt": 96,
	"./mt.js": 96,
	"./my": 97,
	"./my.js": 97,
	"./nb": 98,
	"./nb.js": 98,
	"./ne": 99,
	"./ne.js": 99,
	"./nl": 100,
	"./nl-be": 101,
	"./nl-be.js": 101,
	"./nl.js": 100,
	"./nn": 102,
	"./nn.js": 102,
	"./pa-in": 103,
	"./pa-in.js": 103,
	"./pl": 104,
	"./pl.js": 104,
	"./pt": 105,
	"./pt-br": 106,
	"./pt-br.js": 106,
	"./pt.js": 105,
	"./ro": 107,
	"./ro.js": 107,
	"./ru": 108,
	"./ru.js": 108,
	"./sd": 109,
	"./sd.js": 109,
	"./se": 110,
	"./se.js": 110,
	"./si": 111,
	"./si.js": 111,
	"./sk": 112,
	"./sk.js": 112,
	"./sl": 113,
	"./sl.js": 113,
	"./sq": 114,
	"./sq.js": 114,
	"./sr": 115,
	"./sr-cyrl": 116,
	"./sr-cyrl.js": 116,
	"./sr.js": 115,
	"./ss": 117,
	"./ss.js": 117,
	"./sv": 118,
	"./sv.js": 118,
	"./sw": 119,
	"./sw.js": 119,
	"./ta": 120,
	"./ta.js": 120,
	"./te": 121,
	"./te.js": 121,
	"./tet": 122,
	"./tet.js": 122,
	"./tg": 123,
	"./tg.js": 123,
	"./th": 124,
	"./th.js": 124,
	"./tl-ph": 125,
	"./tl-ph.js": 125,
	"./tlh": 126,
	"./tlh.js": 126,
	"./tr": 127,
	"./tr.js": 127,
	"./tzl": 128,
	"./tzl.js": 128,
	"./tzm": 129,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 129,
	"./ug-cn": 131,
	"./ug-cn.js": 131,
	"./uk": 132,
	"./uk.js": 132,
	"./ur": 133,
	"./ur.js": 133,
	"./uz": 134,
	"./uz-latn": 135,
	"./uz-latn.js": 135,
	"./uz.js": 134,
	"./vi": 136,
	"./vi.js": 136,
	"./x-pseudo": 137,
	"./x-pseudo.js": 137,
	"./yo": 138,
	"./yo.js": 138,
	"./zh-cn": 139,
	"./zh-cn.js": 139,
	"./zh-hk": 140,
	"./zh-hk.js": 140,
	"./zh-tw": 141,
	"./zh-tw.js": 141
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.ticketsReaded),function(ticket,i){return _c('v-list-tile',{key:i,attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Evento: "+_vm._s(ticket.eventId || 'indefinido')+" - Ingresso: "+_vm._s(ticket.code))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Lido as "+_vm._s(_vm.formatDate(ticket.readedAt))+" - Status: "+_vm._s(ticket.status))])],1),_vm._v(" "),_c('v-list-tile-action',[(ticket.readed)?_c('v-icon',{attrs:{"color":"primary lighten-1"}},[_vm._v("sync")]):_c('v-icon',{attrs:{"color":"error lighten-1"}},[_vm._v("sync_disabled")])],1)],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configs_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3774d58f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configs_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3774d58f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',{attrs:{"two-line":""}},[_c('v-subheader',[_vm._v("Configurações")]),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.openProductsDialog}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("event")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Produtos e Setores")])],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('products-config')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsList_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f302eea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsList_vue__ = __webpack_require__(196);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f302eea2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.events),function(event,index){return [_c('v-list-tile',{key:event.name + index,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.downloadTickets(event)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(event.name))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(event.date_start))])],1)],1),_vm._v(" "),(index + 1 < _vm.events.length)?_c('v-divider',{key:index}):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e741d52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e741d52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('h1',{staticStyle:{"color":"#005D8A"}},[_vm._v("lebillet")]),_vm._v(" "),_c('div',{staticClass:"login-wrapper"},[_c('div',[_c('v-text-field',{attrs:{"label":"E-mail"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"type":"password","label":"Password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},nativeOn:{"click":function($event){return _vm.login($event)}}},[_vm._v("Login")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_common__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_events__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_products__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_tickets__ = __webpack_require__(209);





// import database from './modules/database'




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_3__modules_common__["a" /* default */],
    events: __WEBPACK_IMPORTED_MODULE_4__modules_events__["a" /* default */],
    products: __WEBPACK_IMPORTED_MODULE_5__modules_products__["a" /* default */],
    tickets: __WEBPACK_IMPORTED_MODULE_6__modules_tickets__["a" /* default */]
  }
}));

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


var state = {
  userId: 0,
  userName: ''
};

var mutations = {
  SET_USER_ID: function SET_USER_ID(state, userId) {
    state.userId = userId;
  },
  SET_USER_NAME: function SET_USER_NAME(state, userName) {
    state.userName = userName;
  }
};

var actions = {
  setUserId: function setUserId(_ref, userId) {
    var commit = _ref.commit;

    commit('SET_USER_ID', userId);
  },
  setUserName: function setUserName(_ref2, name) {
    var commit = _ref2.commit;

    commit('SET_USER_NAME', name);
  },
  doLogin: function doLogin(_ref3, _ref4) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    var email = _ref4.email,
        password = _ref4.password,
        router = _ref4.router;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('login', { user: email, pass: password }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.id) {
        commit('SET_USER_ID', data.id);
        commit('SET_USER_NAME', data.name);
        localStorage.setItem('userId', data.id);
        localStorage.setItem('userName', data.name);
        router.push('/events');
      }
    }).catch(function (_) {
      dispatch('setSnackbarColor', 'error');
      dispatch('setSnackbarMessage', 'Login Incorreto');
      dispatch('setSnackbarOpen', true);
    });
  },
  doLogout: function doLogout(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit('SET_USER_ID', 0);
    commit('SET_USER_NAME', '');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    dispatch('eraseLocalEventData');
    dispatch('eraseLocalProductsData');
  },
  tryAutoLogin: function tryAutoLogin(_ref6) {
    var commit = _ref6.commit;

    var userId = localStorage.getItem('userId');
    if (!userId) {
      return;
    }
    commit('SET_USER_ID', userId);
    var userName = localStorage.getItem('userName');
    if (!userName) {
      return;
    }
    commit('SET_USER_NAME', userName);
  }
};

var getters = {
  userId: function userId(state) {
    return state.userId;
  },
  userName: function userName(state) {
    return state.userName;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  productsConfigDialog: false,
  currentPage: '',
  snackbarColor: 'primary',
  snackbarOpen: false,
  snackbarMessage: ''
};

var mutations = {
  OPEN_PRODUCTS_CONFIG_DIALOG: function OPEN_PRODUCTS_CONFIG_DIALOG(state) {
    state.productsConfigDialog = true;
  },
  CLOSE_PRODUCTS_CONFIG_DIALOG: function CLOSE_PRODUCTS_CONFIG_DIALOG(state) {
    state.productsConfigDialog = false;
  },
  SET_CURRENT_PAGE: function SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_SNACKBAR_COLOR: function SET_SNACKBAR_COLOR(state, color) {
    state.snackbarColor = color;
  },
  SET_SNACKBAR_OPEN: function SET_SNACKBAR_OPEN(state, open) {
    state.snackbarOpen = open;
  },
  SET_SNACKBAR_MESSAGE: function SET_SNACKBAR_MESSAGE(state, message) {
    state.snackbarMessage = message;
  }
};

var actions = {
  openProductsConfigDialog: function openProductsConfigDialog(_ref) {
    var commit = _ref.commit;

    commit('OPEN_PRODUCTS_CONFIG_DIALOG');
  },
  closeProductsConfigDialog: function closeProductsConfigDialog(_ref2) {
    var commit = _ref2.commit;

    commit('CLOSE_PRODUCTS_CONFIG_DIALOG');
  },
  setCurrentPage: function setCurrentPage(_ref3, currentPage) {
    var commit = _ref3.commit;

    commit('SET_CURRENT_PAGE', currentPage);
  },
  setSnackbarColor: function setSnackbarColor(_ref4) {
    var commit = _ref4.commit;
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'red';

    commit('SET_SNACKBAR_COLOR', color);
  },
  setSnackbarOpen: function setSnackbarOpen(_ref5, open) {
    var commit = _ref5.commit;

    commit('SET_SNACKBAR_OPEN', open);
  },
  setSnackbarMessage: function setSnackbarMessage(_ref6, message) {
    var commit = _ref6.commit;

    commit('SET_SNACKBAR_MESSAGE', message);
  }
};

var getters = {
  productsConfigDialog: function productsConfigDialog(state) {
    return state.productsConfigDialog;
  },
  currentPage: function currentPage(state) {
    return state.currentPage;
  },
  snackbarColor: function snackbarColor(state) {
    return state.snackbarColor;
  },
  snackbarOpen: function snackbarOpen(state) {
    return state.snackbarOpen;
  },
  snackbarMessage: function snackbarMessage(state) {
    return state.snackbarMessage;
  },
  colorClass: function colorClass(state) {
    return state.snackbarOpen ? state.snackbarColor : '';
  },
  isDark: function isDark(state) {
    return state.snackbarOpen;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



var state = {
  eventsList: [],
  selectedEvent: {}
};

var mutations = {
  SET_EVENTS_LIST: function SET_EVENTS_LIST(state, events) {
    state.eventsList = events;
  },
  SET_SELECTED_EVENT: function SET_SELECTED_EVENT(state, event) {
    state.selectedEvent = event;
    localStorage.setItem('selectedEvent', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(event));
  }
};

var actions = {
  setEventsList: function setEventsList(_ref, userId) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('events', { user: userId }).then(function (response) {
      response.json().then(function (events) {
        commit('SET_EVENTS_LIST', events);
      });
    }).catch(function (_) {
      dispatch('setSnackbarColor', 'error');
      dispatch('setSnackbarMessage', 'Erro ao listar eventos');
      dispatch('setSnackbarOpen', true);
    });
  },
  setSelectedEvent: function setSelectedEvent(_ref2, event) {
    var commit = _ref2.commit;

    commit('SET_SELECTED_EVENT', event);
  },
  eraseLocalEventData: function eraseLocalEventData(_ref3) {
    var commit = _ref3.commit;

    commit('SET_SELECTED_EVENT', {});
    localStorage.removeItem('selectedEvent');
  },
  loadEventFromLocalStore: function loadEventFromLocalStore(_ref4) {
    var commit = _ref4.commit;

    var event = localStorage.getItem('selectedEvent');
    if (!event) {
      return;
    }
    commit('SET_SELECTED_EVENT', JSON.parse(event));
  }
};

var getters = {
  eventsList: function eventsList(state) {
    return state.eventsList;
  },
  selectedEvent: function selectedEvent(state) {
    return state.selectedEvent;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);



var state = {
  products: []
};

var mutations = {
  'SET_PRODUCTS_LIST': function SET_PRODUCTS_LIST(state, products) {
    state.products = products;
    localStorage.setItem('products', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(products));
  },
  'TOGGLE_ALL_PRODUCTS_VALIDATION': function TOGGLE_ALL_PRODUCTS_VALIDATION(state, status) {
    state.products.forEach(function (product) {
      product.enabled = status;
    });
    localStorage.setItem('products', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.products));
  },
  'TOGGLE_PRODUCT_VALIDATION': function TOGGLE_PRODUCT_VALIDATION(state, product) {
    var record = state.products.find(function (element) {
      return element.id + '-' + element.type === product.id + '-' + product.type;
    });
    if (record) {
      record.enabled = product.enabled;
    }
    localStorage.setItem('products', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.products));
  }
};

var actions = {
  setProductsList: function setProductsList(_ref, eventId) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('products', { event: eventId }).then(function (response) {
      response.json().then(function (products) {
        products.forEach(function (product) {
          product.enabled = product.enabled === '1';
        });
        commit('SET_PRODUCTS_LIST', products);
      });
    });
  },
  toggleAllProductsValidation: function toggleAllProductsValidation(_ref2, status) {
    var commit = _ref2.commit;

    commit('TOGGLE_ALL_PRODUCTS_VALIDATION', status);
  },
  toggleProductValidation: function toggleProductValidation(_ref3, product) {
    var commit = _ref3.commit;

    commit('TOGGLE_PRODUCT_VALIDATION', product);
  },
  eraseLocalProductsData: function eraseLocalProductsData(_ref4) {
    var commit = _ref4.commit;

    commit('SET_PRODUCTS_LIST', []);
    localStorage.removeItem('products');
  },
  loadProductsFromLocalStore: function loadProductsFromLocalStore(_ref5) {
    var commit = _ref5.commit;

    var products = localStorage.getItem('products');
    if (!products) {
      return;
    }
    commit('SET_PRODUCTS_LIST', JSON.parse(products));
  }
};

var getters = {
  products: function products(state) {
    return state.products;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-br');

var state = {
  tickets: [],
  ticketsReaded: []
};

var mutations = {
  'SET_TICKETS_LIST': function SET_TICKETS_LIST(state, tickets) {
    state.tickets = tickets;
    localStorage.setItem('tickets', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tickets));
  },
  'SET_TICKETS_READED_LIST': function SET_TICKETS_READED_LIST(state, ticketsReaded) {
    state.ticketsReaded = ticketsReaded;
    localStorage.setItem('ticketsReaded', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ticketsReaded));
  },
  'READ_TICKET': function READ_TICKET(state, _ref) {
    var ticket = _ref.ticket,
        eventId = _ref.eventId;

    ticket.eventId = eventId;
    state.ticketsReaded.push(ticket);
    localStorage.setItem('ticketsReaded', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.ticketsReaded));
  }
};

var dispatchInvalid = function dispatchInvalid(dispatch) {
  dispatch('setSnackbarColor', 'error');
  dispatch('setSnackbarMessage', 'Ingresso inválido');
  dispatch('setSnackbarOpen', true);
};

var dispatchNoAllowed = function dispatchNoAllowed(dispatch) {
  dispatch('setSnackbarColor', 'orange darken-3');
  dispatch('setSnackbarMessage', 'Setor Inválido');
  dispatch('setSnackbarOpen', true);
};

var dispatchAllowed = function dispatchAllowed(dispatch, data) {
  dispatch('setSnackbarColor', data.status === 'Permitido' || data.status === 'Ativo' ? 'green darken-2' : 'error');
  dispatch('setSnackbarMessage', data.status === 'Permitido' || data.status === 'Ativo' ? 'Liberado' : data.status);
  dispatch('setSnackbarOpen', true);
};

var dispatchAlreadyReaded = function dispatchAlreadyReaded(dispatch, data) {
  var readedAt = null;
  var now = null;
  if (typeof data.readedAt === 'string') {
    readedAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.readedAt).format('h:mm:ss a');
    now = __WEBPACK_IMPORTED_MODULE_2_moment___default()(data.readedAt).fromNow();
  } else {
    readedAt = data.readedAt.format('h:mm:ss a');
    now = data.readedAt.fromNow();
  }
  dispatch('setSnackbarColor', 'error');
  dispatch('setSnackbarMessage', 'Duplicado, lido as ' + readedAt + ' (' + now + ')');
  dispatch('setSnackbarOpen', true);
};

var findAllowed = function findAllowed(products, ticket) {
  var allowed = products.find(function (product) {
    return product.id === ticket.id_product && (product.type === ticket.id_product_type || ticket.id_product_type === null);
  });

  if (allowed) return allowed.enabled || ticket.id_product_type === null;else return false;
};

var offlineReading = function offlineReading(dispatch, commit, getters, state, ticket, eventId, readedAt) {
  var record = state.tickets.find(function (element) {
    return element.code === ticket;
  });
  if (record) {
    var allowed = findAllowed(getters.products, record);
    if (!allowed) {
      dispatchNoAllowed(dispatch);
    } else {
      if (!record.readedAt) {
        record.readedAt = readedAt || __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
      if (record.readed) {
        record.readedAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(parseInt(record.readedAt) * 1000);
        dispatchAlreadyReaded(dispatch, record);
      } else {
        record.readed = true;
        dispatchAllowed(dispatch, record);
      }
      commit('READ_TICKET', { ticket: record, eventId: eventId });
    }
  } else {
    dispatchInvalid(dispatch);
  }
};

var actions = {
  eraseLocalTicketData: function eraseLocalTicketData(_ref2) {
    var commit = _ref2.commit;

    commit('SET_SELECTED_EVENT', {});
    localStorage.removeItem('tickets');
  },
  loadTicketsFromLocalStore: function loadTicketsFromLocalStore(_ref3) {
    var commit = _ref3.commit;

    var tickets = localStorage.getItem('tickets');
    if (!tickets) {
      return;
    }
    commit('SET_TICKETS_LIST', JSON.parse(tickets));
  },
  eraseLocalTicketsReadedData: function eraseLocalTicketsReadedData(_ref4) {
    var commit = _ref4.commit;

    commit('SET_SELECTED_EVENT', {});
    localStorage.removeItem('ticketsReaded');
  },
  loadTicketsReadedFromLocalStore: function loadTicketsReadedFromLocalStore(_ref5) {
    var commit = _ref5.commit;

    var ticketsReaded = localStorage.getItem('ticketsReaded');
    if (!ticketsReaded) {
      return;
    }
    commit('SET_TICKETS_READED_LIST', JSON.parse(ticketsReaded));
  },
  setEventTickets: function setEventTickets(_ref6, eventId) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('tickets', { event: eventId }).then(function (response) {
      response.json().then(function (tickets) {
        tickets = tickets.map(function (ticket) {
          ticket.readed = ticket.readed === '1';
          ticket.synced = false;
          if (ticket.readedAt) {
            ticket.readedAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(parseInt(ticket.readedAt) * 1000);
          }
          return ticket;
        });
        commit('SET_TICKETS_LIST', tickets);
      });
    }).catch(function (_) {});
  },
  readTicket: function readTicket(_ref7, _ref8) {
    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch,
        getters = _ref7.getters;
    var ticket = _ref8.ticket,
        eventId = _ref8.eventId;

    var readedTicket = state.ticketsReaded.find(function (element) {
      return element.code === ticket;
    });
    var readedAt = null;
    readedAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    if (readedTicket) {
      if (readedTicket.status === 'Inválido') {
        dispatchInvalid(dispatch);
        return;
      }

      var allowed = findAllowed(getters.products, readedTicket);
      if (allowed) {
        if (!readedTicket.readedAt) {
          readedTicket.readedAt = readedAt || __WEBPACK_IMPORTED_MODULE_2_moment___default()();
        }
        dispatchAlreadyReaded(dispatch, readedTicket);
      } else {
        dispatchNoAllowed(dispatch);
      }
    } else {
      var allowedProducts = getters.products.filter(function (product) {
        return product.enabled;
      });
      var params = {
        ticket: ticket,
        event: eventId,
        allowed: allowedProducts.map(function (product) {
          return {
            id_product: product.id,
            id_product_type: product.type
          };
        })
      };

      if (!navigator.onLine) {
        offlineReading(dispatch, commit, getters, state, ticket, eventId, readedAt);
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('read', params).then(function (response) {
        response.json().then(function (data) {
          data.synced = true;
          if (data.status === 'Inválido') {
            dispatchInvalid(dispatch);
          } else if (data.status === 'Setor Inválido') {
            dispatchNoAllowed(dispatch);
          } else {
            var _allowed = findAllowed(getters.products, data);
            if (_allowed) {
              if (!data.readedAt) {
                data.readedAt = readedAt || __WEBPACK_IMPORTED_MODULE_2_moment___default()();
              }
              if (data.readed) {
                data.readedAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(parseInt(data.readedAt) * 1000);
                dispatchAlreadyReaded(dispatch, data);
              } else {
                data.readed = true;
                dispatchAllowed(dispatch, data);
              }
              commit('READ_TICKET', { ticket: data, eventId: eventId });
            } else {
              dispatchNoAllowed(dispatch);
            }
          }
        });
      }).catch(function (_) {
        offlineReading(dispatch, commit, getters, state, ticket, eventId, readedAt);
      });
    }
  },
  syncTickets: function syncTickets(_ref9) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var ticketsReaded = state.ticketsReaded.filter(function (ticket) {
      return !ticket.synced;
    });
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('sync', { tickets: ticketsReaded }).then(function (_) {
      ticketsReaded = state.ticketsReaded.map(function (ticket) {
        ticket.synced = true;
        return ticket;
      });
      commit('SET_TICKETS_READED_LIST', ticketsReaded);
    }).catch(function (_) {});
  }
};

var getters = {
  tickets: function tickets(state) {
    return state.tickets;
  },
  readed: function readed(state) {
    return state.ticketsReaded;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ })
],[145]);


// WEBPACK FOOTER //
// static/js/app.7f46cf44424734e2581d.js